// extracted by mini-css-extract-plugin
module.exports = {"fold-header":"styles_fold-header__2bOUR","foldHeader":"styles_fold-header__2bOUR","export-button":"styles_export-button__1oWc-","exportButton":"styles_export-button__1oWc-"};